import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_feedback.svg';
import Icon, { IconProps } from './icon';

const IconFeedback = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconFeedback;
